import dayjs from 'dayjs';
import c from 'utils/constants';
import { Meta } from 'utils/types';

interface Payload {
  data: any;
  meta: Meta;
}

const token = ({ data }: any) => ({
  data: {
    ...data,
    createdAt: dayjs(data.createdAt).format(c.DATE_TIME_FORMAT),
    updatedAt: dayjs(data.updatedAt).format(c.DATE_TIME_FORMAT),
  },
});

const tokens = ({ data, meta }: Payload) => ({
  meta,
  // TODO: fix any
  data: data.map((dat: any) => token({ data: dat })?.data),
});

export default { token, tokens };
